import _classCallCheck from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
export var createMediaStreamTrackAudioSourceNodeConstructor = function createMediaStreamTrackAudioSourceNodeConstructor(audioNodeConstructor, createNativeMediaStreamTrackAudioSourceNode, getNativeContext) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(MediaStreamTrackAudioSourceNode, _audioNodeConstructor);

    function MediaStreamTrackAudioSourceNode(context, options) {
      _classCallCheck(this, MediaStreamTrackAudioSourceNode);

      var nativeContext = getNativeContext(context);
      var nativeMediaStreamTrackAudioSourceNode = createNativeMediaStreamTrackAudioSourceNode(nativeContext, options);
      return _possibleConstructorReturn(this, _getPrototypeOf(MediaStreamTrackAudioSourceNode).call(this, context, true, nativeMediaStreamTrackAudioSourceNode, null));
    }

    return MediaStreamTrackAudioSourceNode;
  }(audioNodeConstructor);
};